export const PICK_FILES = "PICK_FILES";
export const UPDATE_CATEGORIES = "UPDATE_CATEGORIES";
export const UPLOAD_FILES = "UPLOAD_FILES";
export const CANCEL_FILE_UPLOAD = "CANCEL_FILE_UPLOAD";
export const FILE_UPLOADED = "FILE_UPLOADED";
export const UPLOAD_PROGRESS = "UPLOAD_PROGRESS";
export const CLEAR_FILES = "CLEAR_FILES";
export const UPDATE_VISIBLE_TO = "UPDATE_VISIBLE_TO";
